/**
 * AutoRyse Business Cycle Scenario API — market-wide (not portfolio-scoped) scenario
 * detected daily from curated news + multi-agent consensus.
 *
 * Default base is the same-origin proxy (`/api/business-cycle`) implemented by
 * Azure Functions (`api/businessCycleProxy`) so the browser avoids CORS to the
 * upstream AutoRyse Function App.
 */

export const DEFAULT_BUSINESS_CYCLE_PROXY_PREFIX = "/api/business-cycle";

export function getBusinessCycleBaseUrl() {
  const raw = process.env.REACT_APP_BUSINESS_CYCLE_BASE;
  if (raw === undefined || raw === "") {
    return DEFAULT_BUSINESS_CYCLE_PROXY_PREFIX;
  }
  return String(raw).replace(/\/$/, "");
}

export const BUSINESS_CYCLE_LATEST_PATH = "/latest";
